import {
  RECEIVE_PRODUCT_ALL_SIZES,
  SEND_PRODUCT_NOTIFY_SUBSCRIPTION,
  SEND_PRODUCT_NOTIFY_SUBSCRIPTION_COMPLETE,
  TOGGLE_BRAND_NOTIFY_MODAL,
  TOGGLE_PRODUCT_NOTIFY_MODAL
} from 'constants/reduxActions';
import { SHAMELESS_PLUG_LIST_ID } from 'constants/appConstants';
import { setSessionCookies } from 'actions/session';
import { productBundle } from 'apis/cloudcatalog';
import { subscribeToBrandZSub, subscribeToListZSub, subscribeToStockNotificationZSub } from 'apis/mafia';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { processHeadersMiddleware } from 'middleware/processHeadersMiddlewareFactory';
import { trackError } from 'helpers/ErrorUtils';
import { getSubsiteId } from 'helpers/ClientUtils';
import marketplace from 'cfg/marketplace.json';
import { selectMafiaConfig } from 'selectors/environment';

const { siteId } = marketplace;

export function toggleBrandNotifyModal(modalShown) {
  return { type: TOGGLE_BRAND_NOTIFY_MODAL, modalShown };
}

export function toggleProductNotifyModal(modalShown) {
  return { type: TOGGLE_PRODUCT_NOTIFY_MODAL, modalShown };
}

export function startSendNotificationSubscription() {
  return { type: SEND_PRODUCT_NOTIFY_SUBSCRIPTION };
}

export function sendNotificationSubscriptionComplete(successful) {
  return { type: SEND_PRODUCT_NOTIFY_SUBSCRIPTION_COMPLETE, successful };
}

export function loadedOosProductStyleAndSizes(product) {
  return { type: RECEIVE_PRODUCT_ALL_SIZES, product };
}

export function sendNotificationSubscriptions(emailAddress, stockId, subscribeToNewsletter, brandToSubscribe) {
  return (dispatch, getState) => {
    const state = getState();
    const { cookies } = state;
    const mafiaConfig = selectMafiaConfig(state);

    const subsiteId = getSubsiteId(marketplace);
    dispatch(startSendNotificationSubscription());
    // based on what was supplied we need to make anywhere from one to three API calls
    const apiCalls = [];
    if (stockId) {
      apiCalls.push(
        subscribeToStockNotificationZSub(
          mafiaConfig,
          {
            emailAddress,
            stockIds: [stockId]
          },
          cookies
        )
      );
    }
    if (subscribeToNewsletter) {
      apiCalls.push(
        subscribeToListZSub(
          mafiaConfig,
          {
            siteId,
            subsiteId,
            listIds: [SHAMELESS_PLUG_LIST_ID],
            emailAddress
          },
          cookies
        )
      );
    }
    if (brandToSubscribe) {
      apiCalls.push(
        subscribeToBrandZSub(
          mafiaConfig,
          {
            emailAddress,
            brandIds: [brandToSubscribe]
          },
          cookies
        )
      );
    }

    if (apiCalls.length) {
      return Promise.all(apiCalls).then(responses => {
        const encounteredError = responses.some(resp => resp.status >= 400);
        dispatch(sendNotificationSubscriptionComplete(!encounteredError));
      });
    } else {
      dispatch(sendNotificationSubscriptionComplete(true));
      return Promise.resolve();
    }
  };
}

export function fetchAllProductStyles(productId, productFetcher = productBundle) {
  return (dispatch, getState) => {
    const {
      environmentConfig: {
        api: { cloudcatalog }
      }
    } = getState();
    return productFetcher(cloudcatalog, {
      productId,
      includeOosSizing: true,
      includeOos: true
    })
      .then(processHeadersMiddleware(setSessionCookies(dispatch, getState)))
      .then(fetchErrorMiddleware)
      .then(resp => {
        if (resp.product && resp.product.length === 1) {
          dispatch(loadedOosProductStyleAndSizes(resp.product[0]));
        } else {
          throw new Error('Unable to load oos style and stocks');
        }
      })
      .catch(e => {
        trackError('NON-FATAL', `could not load OOS style data for product ${productId}`, e);
        dispatch(sendNotificationSubscriptionComplete(false));
      });
  };
}
